import { createSlice } from "@reduxjs/toolkit";

const chatbotSlice = createSlice({
  name: "chatbot",
  initialState: {
    messages: [],
    currentThreadId: null,
    loading: false,
    error: null,
    userId: null,
  },
  reducers: {
    sendMessageRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    sendMessageSuccess: (state, action) => {
      const { userMessage, assistantResponse, threadId } = action.payload;
      state.loading = false;
      state.messages.push(userMessage);
      state.messages.push(assistantResponse);
      if (threadId) {
        state.currentThreadId = threadId;
      }
    },
    sendMessageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    
    setCurrentThread: (state, action) => {
      state.currentThreadId = action.payload;
    },
    
    clearChat: (state) => {
      state.messages = [];
      state.currentThreadId = null;
      state.error = null;
    },
  
    loadThreadMessagesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    loadThreadMessagesSuccess: (state, action) => {
      state.loading = false;
      state.messages = action.payload;
    },
    loadThreadMessagesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
  }
});

export const {
  sendMessageRequest,
  sendMessageSuccess,
  sendMessageFailure,
  setCurrentThread,
  clearChat,
  loadThreadMessagesRequest,
  loadThreadMessagesSuccess,
  loadThreadMessagesFailure,
  setUserId
} = chatbotSlice.actions;

export default chatbotSlice.reducer;

